module.exports = __webpack_public_path__ + "img/signup-carousel-first.2c27497b.png";